/* === UPDATED FILE: src/pages/courses/Courses.js === */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Header from '../../components/Header';
import Navbar from '../../components/Navbar';
import Menu from '../../components/Menu';

const SelfPacedCourseCard = ({ course }) => (
    <div className="course-card self-paced-course">
        <img src={course.thumbnail} alt={course.title} className="course-card-image"/>
        <div className="course-content">
            <h3>{course.title}</h3>
            <div className="course-meta">
                <div className="meta-item">
                    <span className="material-icons">play_lesson</span>
                    <span>{course.lectures || 0} Lessons</span>
                </div>
                <div className="meta-item">
                    <span className="material-icons">sell</span>
                    <span>{course.price > 0 ? `₹${parseFloat(course.price).toFixed(2)}` : 'Free'}</span>
                </div>
            </div>
            <Link to={`/courses/${course.id}`} className="course-button">
                Start Learning
            </Link>
        </div>
    </div>
);

const LiveCourseCard = ({ course }) => (
    <div className="course-card live-course">
         {/* You can create a placeholder thumbnail or use a generic one */}
        <img src="https://images.unsplash.com/photo-1543269865-cbf427effbad?q=80&w=870&auto=format&fit=crop" alt={course.title} className="course-card-image"/>
        <div className="course-content">
            <span className="course-status live-course">LIVE</span>
            <h3>{course.title}</h3>
            <div className="course-meta">
                <div className="meta-item">
                    <span className="material-icons">event</span>
                    <span>{new Date(course.start_datetime).toLocaleDateString()}</span>
                </div>
                 <div className="meta-item">
                    <span className="material-icons">schedule</span>
                    <span>{course.schedule_summary}</span>
                </div>
            </div>
             <div className="course-meta">
                 <div className="meta-item">
                    <span className="material-icons">hourglass_empty</span>
                    <span>{course.duration}</span>
                </div>
                <div className="meta-item">
                    <span className="material-icons">sell</span>
                    <span>{course.price > 0 ? `₹${parseFloat(course.price).toFixed(2)}` : 'Free'}</span>
                </div>
            </div>
            <Link to={`/live-courses/${course.id}`} className="course-button">
                View Details & Register
            </Link>
        </div>
    </div>
);


const Courses = () => {
  const [selfPacedCourses, setSelfPacedCourses] = useState([]);
  const [liveCourses, setLiveCourses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('self-paced');

  useEffect(() => {
    const fetchAllCourses = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const [selfPacedRes, liveRes] = await Promise.all([
          axios.get('/api/courses'),
          axios.get('/api/live-courses')
        ]);
        setSelfPacedCourses(selfPacedRes.data);
        setLiveCourses(liveRes.data);
      } catch (err) {
        console.error("Failed to fetch courses:", err);
        setError("Could not load courses. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchAllCourses();
  }, []);

  const renderContent = () => {
    if (isLoading) return <p>Loading courses...</p>;
    if (error) return <p className="error-message">{error}</p>;

    const coursesToDisplay = activeTab === 'live' ? liveCourses : selfPacedCourses;
    const CardComponent = activeTab === 'live' ? LiveCourseCard : SelfPacedCourseCard;

    if (coursesToDisplay.length === 0) {
        return <p>No {activeTab} courses available at the moment.</p>;
    }

    return (
      <div className="courses-list">
        {coursesToDisplay.map(course => (
          <CardComponent key={`${activeTab}-${course.id}`} course={course} />
        ))}
      </div>
    );
  };

  return (
    <div className="courses-page-container">
      <div className="course-tabs">
        <button
          className={`tab-button ${activeTab === 'self-paced' ? 'active' : ''}`}
          onClick={() => setActiveTab('self-paced')}
        >
          Self-Paced Courses
        </button>
        <button
          className={`tab-button ${activeTab === 'live' ? 'active' : ''}`}
          onClick={() => setActiveTab('live')}
        >
          Live Courses
        </button>
      </div>
      <div className="course-content-area">
        {renderContent()}
      </div>
    </div>
  );
};

const CoursesLayout = ({ children }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    
    return (
        <div className="app-container">
            <Menu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
            <Header title="Courses" showBackButton={true} />
            <main className="page-padding">
                {children}
            </main>
            <Navbar onMenuOpen={() => setIsMenuOpen(true)} />
        </div>
    );
};

export { CoursesLayout };
export default Courses;
